import { Route, NavigationGuardNext } from 'vue-router';
import { isOn } from '@/lib/growthbook';

const corporateVerificationGuard = (_to: Route, _from: Route, next: NavigationGuardNext) => {
  if (isOn('sc-automate-corporate-upgrades-enabled')) {
    next();
    return;
  }

  next('/account/seekers/dashboard');
};

export default corporateVerificationGuard;
